import React, { useState } from 'react';

const defaultValue = {
  vendedores: [],
  vendedorAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  page: 0,
  size: 15,
};

export const VendedorContext = React.createContext({});

export const VendedorProvider = (props) => {
  return (
    <VendedorContext.Provider
      value={{
        vendedores: useState(defaultValue.vendedores),
        vendedorAtual: useState(defaultValue.vendedorAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
      }}
    >
      {props.children}
    </VendedorContext.Provider>
  );
};

export const ClienteConsumer = VendedorContext.Consumer;
